export const COMPLIANCE_TEMPLATES = {
  notice: `
  
  `,
  disclosure: `
  <h1
          >The Information provided in this risk review will be used to
          determine the level of insurance cover suitable to meet your needs
        </h1>
        <p>
          Unless otherwise stated, all information provided is to be for the
          next period of insurance. Where we have provided an existing sum
          insured, estimate, or other rating factor, please review and amend
          this as necessary. Where you choose not to enter alternative figures,
          quotations will be obtained on an unchanged figure. Please contact
          your Service Team for any further clarification on insured values,
          policy estimates, etc.
        </p>
        <p
          >The information you provide to us in this document, at meetings, and
          in any other relevant communication, will be used by us to assist you
          to obtain the levels of insurance protection you require. By
          undertaking a review of these, we have the opportunity to ensure that
          when obtaining terms from your existing insurers, and (where
          appropriate) obtaining quotations from alternative insurers, the terms
          obtained reflect accurately your needs and requirements. Therefore, it
          is essential that the information provided is as accurate as possible
          to ensure your Business is provided with the appropriate level of
          insurance cover by insurers, and that you pay the correct premium.</p
        >

<p><img class="mce-pagebreak" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-mce-resize="false" data-mce-placeholder></p>

  <h1
          >Important – Duty to Make a Fair Presentation of the Risk/Disclose
          Material Information. Please read carefully.</h1
        >
        <h3>You have a duty to make a fair presentation of the risk</h3>
        <p
          >To meet this duty you still need to disclose all material information
          to insurers which is known to you (or which ought to be known to you).
          Information is material if it would influence the judgement of a
          prudent Insurer in establishing the premium or determining whether to
          underwrite the risk and, if so, on what terms.
        </p>
        <p
          >Material information does not necessarily have to actually increase
          the risk of the insurance under consideration.
          </p>
        <p>
          Under the Act you are
          deemed to know information if it is known to any individuals in the
          categories below:
          </p>
        <ol style="list-style: lower-alpha">
          <li
            >Anyone within your business in a senior management or decision
            making role, and
          </li>
          <li>Anyone responsible for arranging the insurances.</li>
        </ol>
        <p>
          Furthermore, under the Act you “ought to know” what should reasonably
          have been revealed by a reasonable search for information held
          internally or externally (including by any third parties to whom
          services are outsourced, consultants and agents).
        </p>
        <p>
          In order to be able to argue that you have satisfied the duty, should
          an insurer allege that you have not, you must now do the following:
        </p>
        <ol>
          <li
            >Carefully consider who are the individuals who may fall into
            categories (a) or (b) above, record this in writing and explain your
            reasoning;
          </li>
          <li
            >Make enquiries of those individuals as to whether they are aware of
            any material information (having explained to them what this
            means);</li
          >
          <li>Record the results of these enquiries in writing; and</li>
          <li
            >Consider whether any material information could be held anywhere
            other than with the individuals identified at (a) and (b). If so,
            you will need to carry out a reasonable search. This could mean
            making enquiries of individuals or may in some circumstances mean
            having to carry out an electronic and/or physical search of records.
          </li>
        </ol>
        <p
          >It is important to bear in mind that if material information is held
          by third parties such as accountants or lawyers, or internally by
          branch offices, even if it is not known to the individuals you have
          identified at paragraphs (a) and (b), it may need to be disclosed.
          Please note that you must not rely on information that may be held by
          us in relation to other policies that we may place on your behalf. You
          must ensure that all relevant information is provided to us for each
          and every policy that we place on your behalf. We accept no liability
          to you in this respect.
        </p>
        <p>
          Your enquiries must cover all relevant group companies, branch offices
          etc. and the relevant personnel within them. You must ensure you make
          a full written record of the search made and the responses provided to
          ensure that you have evidence in the event of any claim being made.
        </p>
        <p>
          The duty of fair presentation of risk also applies when there are
          changes to the risk and amendments made to any insurance policy
          (whenever incepted) after 12 August 2016.
        </p>
        <p>
          In completing a proposal or claim form or questionnaire for your
          Insurer(s), the accuracy and completeness of all answers, statements
          and/or information is your responsibility and it is of paramount
          importance that all relevant information is provided and that it is
          accurate.
        </p>
        <p>
          If you become aware of any material information that you supplied
          before the contract of insurance is finalised is incorrect or has been
          omitted, you should inform us immediately.
        </p>
        <h3
          >What are the consequences of not making a fair presentation of the
          risk?
        </h3>
        <p>
          Under the Act, in the event that there is a breach of duty of fair
          presentation of risk, the remedies available to insurers vary
          dependent on whether the breach is deliberate or reckless or
          otherwise. For deliberate or reckless breaches the insurer may avoid
          the contract, refuse all claims and retain the premium paid.
        </p>
        <p>
          For other, non-fraudulent or non-reckless breaches the remedy depends
          on what the insurer would have done had a fair presentation of the
          risk been made. If the insurer would not have accepted the risk it can
          avoid the contract but must refund premiums paid.
        </p>
        <p>
          If the insurer would have accepted the risk on other terms the
          contract is to be treated as if those terms applied, in the event that
          a higher premium would have been charged any claims payments can be
          reduced proportionately.
        </p>
        <p>
          This latter provision is especially important because if insurers can
          show that they would have charged only a modest additional premium,
          the impact on a claim could be disproportionately large.
        </p>
        <p>
          For certain policies the insurer may change the remedies available to
          them from those described above. In such circumstances we will inform
          you of the changes and what this means for you.
        </p>
        <p>
          It is therefore important that you understand and comply with your
          obligations under the Act.
        </p>

        <p><img class="mce-pagebreak" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-mce-resize="false" data-mce-placeholder="" data-mce-selected="1"></p>

 <h1
          >Examples (Non exhaustive) of Material Facts that should be
          disclosed:</h1
        >
        <h3>General</h3>
        <ul>
          <li
            >If the Business has ever been subject to an investigation by HM
            Revenue & Customs which resulted in prosecution</li
          >
          <li
            >Any Director, Partner or family member involved with the Business
            must specifically disclose if they have:
            <ul>
              <li
                >Changes in financial circumstances - ever been declared
                bankrupt, insolvent or liquidated.</li
              >
              <li
                >Ever been the subject of a Count Court Judgement, an individual
                Voluntary Arrangement, a Company Voluntary Arrangement or a
                Sheriff Court Decree.</li
              >
            </ul>
          </li>
          <li>Ever been disqualified from being a company director</li>
          <li
            >Ever had an insurance proposal declined, renewal refused or
            insurance cancelled or special terms imposed</li
          >
          <li
            >Been convicted of or charged (but not yet tried) or been given an
            Official Police Caution in respect of any criminal offence other
            than a motoring offence</li
          >
          <li
            >Been convicted of fraud, robbery, theft of handling stolen goods
            during the past 5 years, unless spent by the Rehabilitation of
            Offenders Act</li
          >
          <li>Criminal records of Directors, Partners or Senior staff </li>
          <li
            >Acquisition or disposal of companies, or businesses including joint
            ventures or consortia in which you have an interest</li
          >
          <li
            >Any Improvement Notice(s), Prohibition Notice(s), or Formal Court
            Proceeding issued by the HSE or Local Authorities against you.
          </li>
          <li
            >Any circumstances/accident which could give rise to a claim, not
            already notified.
          </li>
          <li>Any change in business activity processes </li>
          <li>Being awarded a contract outside UK/ROI.</li>
          <li
            >Work in or providing products/services into a Sanctioned
            Territory</li
          >
        </ul>

        <h3>Property Damage/ Business Interruption </h3>
        <ul>
          <li> Additional assets purchased or disposed of</li>
          <li
            >Alterations or refurbishments to premises or changes in their use
          </li>
          <li
            >Changes in Security System arrangements or Alarm Warranty cannot be
            complied with</li
          >
          <li>Changes in Fire Detection systems </li>
          <li>Premises become unoccupied or occupied</li>
          <li>Sprinkler System not operational</li>
          <li>Additional locations including Third Party arrangements</li>
        </ul>

        <h3>Computer </h3>
        <ul>
          <li>Additional computer equipment/laptops </li>
        </ul>

        <h3>Engineering </h3>
        <ul>
          <li> Additional assets purchased or disposed of</li>
          <li>Hired In Plant limit needing increased</li>
          <li>Additional items requiring inspection </li>
        </ul>

        <h3>Motor Fleet </h3>
        <ul>
          <li>
            Any convictions, medical conditions or accidents of which your
            Insurers may be unaware. It is recommended that a regular physical
            check of driving licences is carried out together with a Declaration
            of Accident history. A Driver’s Declaration Form is available for
            this purpose</li
          >
          <li
            >Notifications to DVLA that require a change to the Driver’s
            Licence</li
          >
          <li>Details of young drivers </li>
          <li
            >Inexperienced drivers (with less than 1 years driving experience)
          </li>
          <li
            >Drivers with a Non-UK Licence, irrespective of whether they are
            temporary or permanent drivers</li
          >
          <li>Modifications to or change in use of vehicles</li>
          <li
            >Personal ownership of vehicles covered by Company Fleet policy</li
          >
          <li>Medical conditions </li>
          <li>Vehicles being used for Hire and Reward</li>
        </ul>

        <h3>Employer's Liability</h3>
        <ul>
          <li> Foreign National persons being employed </li>
          <li>Employees issued with non-UK contracts of employment</li>
        </ul>

        <h3>Public/Products Liability </h3>
        <ul>
          <li>New products or services being undertaken</li>
          <li>Changes in contractual arrangements</li>
          <li>“Hold Harmless” contract conditions being requested</li>
          <li>New territories for imports and/or exports</li>
          <li>Sites/Buildings become unoccupied </li>
          <li>Any actual or pending prosecutions</li>
          <li>“Additional Insured” being requested by customers</li>
          <li>“Waiver of Subrogation” being requested by customers</li>
        </ul>

        <h3>Management Liability </h3>
        <ul>
          <li>New companies being acquired or disposed of</li>
          <li>Newly appointed or retired Directors</li>
        </ul>

        <h3>Trustees Liability </h3>
        <ul>
          <li>New Trusts set up or disposed of</li>
        </ul>

        <h3>Professional Indemnity </h3>
        <ul>
          <li>Any previous complaints</li>
          <li>Any previous claims with full details</li>
          <li>Struck off any professional registers</li>
          <li>Any change in your activities</li>
          <li>Compliance settled in house or outsourced</li>
          <li>Pension activities that have been arranged</li>
          <li>Origins of business</li>
          <li>Current sign off procedure</li>
        </ul>

        <h3>Business Travel </h3>
        <ul>
          <li>Long-term Secondees requiring cover</li>
          <li>Consultants requiring cover </li>
          <li>Directors requiring Personal Travel</li>
          <li
            >Travelling to countries, against the current advice of the Foreign
            Office (latest updates are available online at
            www.gov.uk/foreign-travel-advice)
          </li>
          <li>Details of pre-existing medical conditions prior to Travel</li>
        </ul>

        <h3>Hired In Plant </h3>
        <ul>
          <li>Hired In Plant limit needing increase</li>
        </ul>

        <h3>Contractors All Risks </h3>
        <ul>
          <li>An increased Contract Price Limit required </li>
          <li>Contracts requiring DE5 cover </li>
          <li>Offsite Storage above the Policy Limit required </li>
          <li>Maintenance Period longer than 12 months</li>
        </ul>

        <h3>Marine Transit </h3>
        <ul>
          <li>Transits to countries not already notified to the Insurer</li>
          <li>Additional Depots purchased or being used</li>
          <li>Transits by Sea or Air required</li>
          <li>Moving goods for others for Hire and Reward</li>
        </ul>

        <p><img class="mce-pagebreak" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-mce-resize="false" data-mce-placeholder="" data-mce-selected="1"></p>

         <h1>Insurance Act 2015</h1>
        <h3>Knowledge of the insured</h3>
        <p
          >This is an obligation which will vary based on business
          circumstances: You must make adequate enquiries within your business
          to identify and verify information relevant to the risk(s)
          concerned</p
        >
        <p>The knowledge of the Insured is that</p>
        <ul>
          <li>of the “senior management” of the business</li>
          <li>of those responsible for the insurance</li>
        </ul>
        <p
          >obtained from a “Reasonable Search” of information available. This
          may include parties both within the business and outsourced functions,
          where relevant to the risks being placed</p
        >
        <h3>"Clear and accessible"</h3>
        <p
          >Information must be presented to insurers in a clear and accessible
          manner
        </p>
        <p
          >This addresses the clarity of presentation and how able insurers are
          to assess the risk. “Data dumping” of large amounts of information
          without signposting is unacceptable</p
        >
        <p
          >There is also an additional requirement to adequately highlight
          unusual activities and/or known areas of concern that could affect the
          risk
        </p>

        <p><img class="mce-pagebreak" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-mce-resize="false" data-mce-placeholder="" data-mce-selected="1"></p>

        <h1>Company Background</h1>
  `,
};
